import { Component, ChangeDetectionStrategy } from '@angular/core';
import {GuestComponent} from "../../../layout/guest/guest.component";
import {RouterLink} from '@angular/router';
import {MetaTitle} from '../../../../decorator/meta-title';

@Component({
  selector: 'app-register-success',
  imports: [
    GuestComponent,
    RouterLink
  ],
  templateUrl: './register-success.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './register-success.component.scss'
})
@MetaTitle('Registration received')
export class RegisterSuccessComponent {

}
